var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.01,13.73c-2.35,0-4.26-1.9-4.26-4.24s1.91-4.24,4.26-4.24s4.26,1.9,4.26,4.24S14.35,13.73,12.01,13.73z M12.01,6.75 c-1.52,0-2.76,1.23-2.76,2.74c0,1.51,1.24,2.74,2.76,2.74s2.76-1.23,2.76-2.74C14.76,7.98,13.53,6.75,12.01,6.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25,20.25c-0.41,0-0.75-0.34-0.75-0.75v-2.25c0-2.86,1.86-5.42,4.53-6.22c0.4-0.12,0.81,0.11,0.93,0.5 c0.12,0.4-0.11,0.81-0.5,0.93C7.42,13.08,6,15.05,6,17.25v2.25C6,19.91,5.66,20.25,5.25,20.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75,20.25c-0.41,0-0.75-0.34-0.75-0.75v-2.25c0-0.98-0.42-1.94-1.33-3.02c-0.27-0.32-0.22-0.79,0.09-1.06 c0.31-0.26,0.79-0.23,1.06,0.09c0.72,0.86,1.67,2.2,1.67,3.98v2.25C19.5,19.91,19.16,20.25,18.75,20.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23C5.93,23,1,18.07,1,12S5.93,1,12,1s11,4.93,11,11S18.07,23,12,23z M12,2.5c-5.24,0-9.5,4.26-9.5,9.5s4.26,9.5,9.5,9.5 s9.5-4.26,9.5-9.5S17.24,2.5,12,2.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.820f9174e9dcb98ea2032fda970a8bba.svg";
export { ForwardRef as ReactComponent };